import script from "./CurrentDay.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentDay.vue?vue&type=script&setup=true&lang=js"

import "./CurrentDay.vue?vue&type=style&index=0&id=167eddb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167eddb0"]])

export default __exports__